import gql from 'graphql-tag';

const deleteSubscriptionMutation = gql`
  mutation deleteSubscriber($input: DeleteSubscriberInput!) {
    deleteSubscriber(input: $input) {
      success
      errors
    }
  }
`;

export default deleteSubscriptionMutation;
